/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Sidebar } from 'primitives';
import { MilestonesDiffingToggle, MilestonesSection } from 'components';

import * as Styled from './Sidebar.styled';

export default function ReadmeVersionsSidebar() {
  return (
    // @ts-expect-error TS2769
    <Sidebar $isVisible>
      {/* @ts-expect-error TS2339 */}
      <Sidebar.Inner>
        <Styled.SidebarSection>
          {/* @ts-expect-error TS2339 */}
          <Sidebar.Title>Versions</Sidebar.Title>
          <MilestonesSection canCopyTo={false} />
        </Styled.SidebarSection>
        {/* @ts-expect-error TS2339 */}
      </Sidebar.Inner>
      <MilestonesDiffingToggle />
    </Sidebar>
  );
}
